export const ITEM_HEIGHT_CACHE: Record<string, number> = {}
